import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

// Initialize the MSAL instance
let msalInstance: PublicClientApplication | null = null;

// Only initialize on client-side
if (typeof window !== 'undefined') {
  try {
    msalInstance = new PublicClientApplication(msalConfig);
  } catch (error) {
    console.error('MSAL initialization error:', error);
  }
}

export default msalInstance; 